/** Waits, in milliseconds, before each retry of a failed Patient search on client chart load. */
export const CLIENT_LOAD_RETRY_DELAYS_MS = [1000, 2000, 4000];

/**
 * OperationOutcome issue codes for a server answer that a retry cannot change: no access, no
 * session, or no such Patient. A network failure in Medplum's batch request has the code `invalid`,
 * so `invalid` stays retryable.
 */
export const CLIENT_LOAD_FINAL_ISSUE_CODES = [
  "forbidden",
  "security",
  "login",
  "expired",
  "not-found",
];

/** HTTP statuses for a server answer that a retry cannot change. */
export const CLIENT_LOAD_FINAL_STATUSES = [401, 403, 404];
